import React from 'react';
import { concatStrings } from '../utilities';

import DfbSymbol from './dfb_symbol';

const DfbIcon = ({ tagName, add_class, icon_type, ...otherProps }) => {
  const TagName = `${tagName.toLowerCase()}`
  
  return (
    <TagName className={concatStrings('dfb-Icon', add_class)} {...otherProps}>
      <DfbSymbol icon_type={icon_type} />
    </TagName>
  );
}
DfbIcon.defaultProps = {
  tagName: 'span',
}
export default DfbIcon;
